import { useState, useEffect} from "react";
function Thumbnail({item, settings, className}) {
    const [src, setSrc] = useState();

    useEffect(()=>{
        if(settings.defaultThumbnail.url && settings.defaultThumbnail.apply!=='none'){
            if(settings.defaultThumbnail.apply==='all'){
                setSrc(settings.defaultThumbnail.url);
            }else if(settings.defaultThumbnail.apply==='missing'){
                if(!item.thumbnail){
                    setSrc(settings.defaultThumbnail.url);
                }else{
                    setSrc(item.thumbnail);
                }
            }
        }
        else if(item.thumbnail){
            setSrc(item.thumbnail);
        }
    },[]);

    return(<>
        {src && <img
            loading="lazy"
            src={src}
            alt={item.name}
            className={`${className} vf-gallery-thumb object-cover object-center h-full w-full`}
        />}
    </>)
}

export default Thumbnail;